
export default {
  name: 'MoleculeCertifications'
}
